import React, { useContext } from 'react';
import { List, ListItem } from 'flowbite-react';
import { Box, Button } from '../../../../../components';
import { OfferContext, OfferContextData } from '../../utils/OfferProvider';
import { DateTime } from "luxon";

const Step2: React.FC = () => {
  const {
    offerTrialDuration,
    productValueInCents,
    offerTrialPrice,
    showNextPaymentDate,
    showCancellationDisclaimer,
    showAddCustom,
    secondTermsOfServiceDescription,
    showSecondTermsOfService,
    addCustomText,
    productName,
    ctaButtonTitle,
  } = useContext(OfferContext) as OfferContextData;

  if (!showNextPaymentDate && !showCancellationDisclaimer && !showAddCustom) {
    return (
      <Box className='p-[30px] flex flex-col gap-5'>
        <div className="flex justify-between items-center gap-3">
          <div className="h-4 my-0.5 w-[130px] rounded-full bg-neutral-300 " />
          <div>
            <div className="h-4 my-0.5 w-[67px] rounded-full bg-neutral-200 " />
          </div>
        </div>
        <Button size='lg'>
          {ctaButtonTitle}
        </Button>
        <div className="h-4 w-[130px] rounded-full bg-neutral-300 " />
      </Box>
    );
  }

  const NextSubscriptionText = () => {
    const planIsAnnual = () => Boolean(productName.includes('Annual'));
    const trialDuration = Number(offerTrialDuration || 0);

    const today = DateTime.now();
    const trialEndDay = today.plus({ days: trialDuration }).toFormat('MMM dd, yyyy');

    const nextChargeDateAsText = planIsAnnual()
      ? today.plus({ years: 1 }).toFormat('MMM dd, yyyy')
      : today.plus({ months: 1 }).toFormat('MMM dd, yyyy');

    return (
      <>
        {Number(offerTrialDuration) > 0 && Number(offerTrialPrice) > 0 &&
          (`Your next subscription billing of $${productValueInCents}/${planIsAnnual() ? 'year' : 'month'} begins on ${trialEndDay}.`)
        }
        {Number(offerTrialDuration) > 0 && Number(offerTrialPrice) === 0 && (
          `${offerTrialDuration} days free from today, then just $${productValueInCents}/${planIsAnnual() ? 'year' : 'month'} (plus applicable taxes), begins on ${trialEndDay}.`
        )}
        {Number(offerTrialDuration) === 0 && (
          `Your next subscription billing of $${productValueInCents}/${planIsAnnual() ? 'year' : 'month'} begins on ${nextChargeDateAsText}.`
        )}
      </>
    );
  }

  return (
    <Box className='p-[30px] flex flex-col gap-3.5'>
      <div className="flex justify-between items-center gap-3">
        <div className="h-4 my-0.5 w-[130px] rounded-full bg-neutral-300 " />
        <div>
          <div className="h-4 my-0.5 w-[67px] rounded-full bg-neutral-200 " />
        </div>
      </div>
      <Button size='lg'>
        {ctaButtonTitle}
      </Button>

      <div className='text-sm text-neutral-800 font-semibold'>
        {showNextPaymentDate && (
          <p className='mb-3.5'>
            <NextSubscriptionText />
          </p>
        )}
        {showCancellationDisclaimer && (
          <span className='mr-0.5'>
            {`By clicking "${ctaButtonTitle}", I acknowledge that I'm authorizing Authorify to automatically charge my default payment method today and then every month (recurring payment), unless I cancel.`}
          </span>
        )}
        {showSecondTermsOfService && (
          <span className='mr-0.5'>
            {secondTermsOfServiceDescription || 'I also agree to the'} <u>Terms of Service</u> and <u>Privacy Policy</u>.
          </span>
        )}
        {showAddCustom && addCustomText ? (
          <p className='mt-3.5'>
            {addCustomText}
          </p>
        ) : (
          <div className="h-4 mt-4 w-[130px] rounded-full bg-neutral-300 " />
        )}
      </div>
    </Box>
  );
};

export default Step2;